<template>
<div>
    <nav aria-label="Page navigation example">
        
        <ul class="pagination justify-content-center">
            <li class="page-item"><a class="page-link" href="#" @click="setPrev">Anterior</a></li>
            <li v-if="hasMore(1)" class="page-item"><span class="page-link">...</span></li>
            <li v-for="page in totalPages" :class="['page-item', isActivePage(page-1)]" v-if="isVisible(page)">
                <a class="page-link" href="#" @click="setLink(page-1)">{{page}}</a>
            </li>
            <li v-if="hasMore(2)" class="page-item"><span class="page-link">...</span></li>
            <li class="page-item"><a class="page-link" href="#" @click="setNext">Siguiente</a></li> <span class="pa-2"> {{total_items}} Registros</span>
        </ul>
    </nav>
</div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        total: {
            type: Number,
            required: true,
        },
        links: {
            type: Object,
            required: true
        },
        items: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    created: function () {
        this.activePage = 0;
        this.total_items = this.total;
    },
    mounted: async function () {
        await this.setPages();
    },
    watch: {
        total_items: function () {
            this.totalPages = [];
            this.setPages();
        },
    },
    data() {
        return {
            name: "PaginacionComponent",
            activePage: 0,
            total_items: 0,
            totalPages: [],
        };
    },

    methods: {
        setLink: function (pageNumber) {
            if (this.options.tipo == 1) {
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                axios.post(`${this.links.url}?offset=${pageNumber*this.options.size}&limit=${this.options.size}`, this.options.filters).then(response => {
                    this.items.items = response.data.results;
                    this.links.next = response.data.next;
                    this.links.prev = response.data.previous;
                    this.total_items = response.data.count;
                    this.$root.$dialogLoader.hide();
                }).catch(error => {

                    this.$root.$dialogLoader.hide();
                });
            }
        },
        setPrev: function () {
            if (this.links.prev == null || this.links.prev == '' || this.links.prev == undefined) {
                console.log("no esta la variable prev");
            } else {
                if (this.options.tipo == 1) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    axios.post(this.links.prev, this.options.filters).then(response => {
                        this.items.items = response.data.results;
                        this.links.next = response.data.next;
                        this.links.prev = response.data.previous;
                        this.total_items = response.data.count;
                        this.$root.$dialogLoader.hide();
                    }).catch(error => {
                        this.$root.$dialogLoader.hide();
                    });
                }
            }
        },
        setNext: function () {
            if (this.links.next == null || this.links.next == '' || this.links.next == undefined) {
                console.log("no esta la variable next");
            } else {
                if (this.options.tipo == 1) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    axios.post(this.links.next, this.options.filters).then(response => {
                        this.items.items = response.data.results;
                        this.links.next = response.data.next;
                        this.links.prev = response.data.previous;
                        this.total_items = response.data.count;
                        this.$root.$dialogLoader.hide();
                    }).catch(error => {
                        this.$root.$dialogLoader.hide();
                    });
                }
            }
        },
        setPages: function () {
            let paginas = Math.ceil(this.total_items / this.options.size);
            for (let i = 0; i < paginas; i++) {
                this.totalPages.push(i + 1);
            }
        },
        hasMore: function (side) {
            if (side == 1) {
                return (this.activePage - 3) >= 0;
            } else {
                return (this.totalPages.indexOf(this.activePage + 4)) != -1;
            }
        },
        isVisible: function (page) {
            if (this.totalPages.length == 5) {
                return true;
            } else {
                if (this.activePage < 3 && page < 6) {
                    return true;
                } else {
                    if (this.activePage > this.totalPages[this.totalPages.length - 4] && page > this.totalPages[this.totalPages.length - 6]) {
                        return true;
                    } else {
                        if (page == this.activePage - 1 || page == this.activePage || page == this.activePage + 2 || page == this.activePage + 3 || page == this.activePage + 1) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            }
        },
        isActivePage: function (page) {
            if (this.links.next == null || this.links.next == '' || this.links.next == undefined) {
                if (page == this.totalPages.length - 1) {
                    this.activePage = page;
                    return 'active disabled';
                }
            } else {
                if (this.options.tipo == 1) {
                    let urlParams = new URLSearchParams(this.links.next);
                    let val = urlParams.get('offset');

                    if (page == ((val / this.options.size) - 1)) {
                        this.activePage = page;
                        return 'active disabled';
                    }
                }
            }
        },
        filterData: function () {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            axios.post(this.links.url, this.options.filters).then(response => {
                this.items.items = response.data.results;
                this.links.next = response.data.next;
                this.links.prev = response.data.previous;
                this.total_items = response.data.count;
                this.$root.$dialogLoader.hide();
            }).catch(error => {
                this.$root.$dialogLoader.hide();
            });

        },
    }
};
</script>
